import apiClient from './api/apiClient'
import { API_ROUTES } from '../constants/apiRoutes'

let houseLabelsCache = null
let houseLabelsPromise = null
let sauterLabelsCache = null
let sauterLabelsPromise = null

const buildHouseDeviceLabels = async () => {
    const labels = {}
    const atlanticUrl = new URL(API_ROUTES.DEVICES_GET_DATA, window.location.origin)
    atlanticUrl.searchParams.append('dataGroup', 'atlantic')
    const spaUrl = new URL(API_ROUTES.DEVICES_GET_DATA, window.location.origin)
    spaUrl.searchParams.append('dataGroup', 'spa')

    const [atlanticResult, spaResult] = await Promise.allSettled([
        apiClient.get(atlanticUrl.toString()),
        apiClient.get(spaUrl.toString())
    ])

    if (atlanticResult.status === 'fulfilled') {
        const data = atlanticResult.value
        if (data?.devicesData) {
            Object.entries(data.devicesData).forEach(([name, device]) => {
                if (device?.label) {
                    labels[name] = device.label
                }
            })
        }
    }

    if (spaResult.status === 'fulfilled') {
        const data = spaResult.value
        if (data?.devicesData?.SPA?.label) {
            labels.SPA = data.devicesData.SPA.label
        }
    }

    return labels
}

const buildSauterDeviceLabels = async () => {
    const labels = {}
    const devicesUrl = new URL(API_ROUTES.SAUTER_DEVICES_DATA, window.location.origin)
    const result = await Promise.allSettled([apiClient.get(devicesUrl.toString())])

    if (result[0].status === 'fulfilled') {
        const data = result[0].value
        if (data?.devices) {
            Object.entries(data.devices).forEach(([name, device]) => {
                if (device?.label) {
                    labels[name] = device.label
                }
            })
        }
    }

    return labels
}

export const getHouseDeviceLabels = () => {
    if (houseLabelsCache) {
        return Promise.resolve(houseLabelsCache)
    }
    if (houseLabelsPromise) {
        return houseLabelsPromise
    }
    houseLabelsPromise = buildHouseDeviceLabels().then((labels) => {
        houseLabelsCache = labels
        houseLabelsPromise = null
        return labels
    })
    return houseLabelsPromise
}

export const getSauterDeviceLabels = () => {
    if (sauterLabelsCache) {
        return Promise.resolve(sauterLabelsCache)
    }
    if (sauterLabelsPromise) {
        return sauterLabelsPromise
    }
    sauterLabelsPromise = buildSauterDeviceLabels().then((labels) => {
        sauterLabelsCache = labels
        sauterLabelsPromise = null
        return labels
    })
    return sauterLabelsPromise
}
